import { forwardRef } from 'react';
import { InputDuration, InputDurationProps } from './input';

export const NonNullInputDuration = forwardRef<any, InputDurationProps>(
  (props, ref) => {
    const { value } = props;

    return value != null ? <InputDuration {...props} ref={ref} /> : null;
  },
);

NonNullInputDuration.displayName = 'NonNullInputDuration';
